module.exports = __webpack_public_path__ + "img/settings.3bf6bdf9.svg";